import { useState } from "react";
import { Button, Collapse } from "reactstrap";
import { learningObjectiveSchema } from "./constants";
import { useFieldArray, Controller } from "react-hook-form";
import { FiX } from "react-icons/fi";

export const NestedFieldArray = ({ register, control, namePrefix, index, errors }) => {
	const { fields, append, remove } = useFieldArray({
		control,
		name: namePrefix,
	});

	return (
		<div
			className="col-12 py-2 mb-4"
			style={{
				border: "2px solid #ffffff25",
				borderRadius: 8,
				backgroundColor: "#1D253B",
			}}
		>
			<div
				className="row pb-2"
				style={{
					borderBottom: "2px solid #ffffff25",
				}}
			>
				<dt className="col-1 text-info text-center">No</dt>
				<dt className="col-10 text-info">Learning Objective</dt>
				<dt
					className="col-1 text-info text-center"
					onClick={() => {
						append(learningObjectiveSchema);
					}}
				>
					<span className="border border-warning text-warning px-2 rounded" color="warning" size="sm" type="button">
						+
					</span>
				</dt>
			</div>
			{fields.length ? (
				fields.map((field, jindex) => (
					<div key={field.id} className="row pt-2 align-items-center">
						<span className="col-1 text-white text-center">{jindex + 1}</span>
						<span className="col-10 text-white">
							<Controller
								name={`${namePrefix}[${jindex}].name`}
								control={control}
								rules={{ required: { value: true, message: "Learning objective is required, when added, delete if not required" } }}
								render={({ field, fieldState: { error } }) => (
									<>
										<input
											type="text"
											className="form-control"
											placeholder={`Lesson ${index + 1} Learning Objective ${jindex + 1}`}
											{...field}
										/>
										{error && (
											<div className="text-center">
												<small className="text-danger">{error?.message}</small>
											</div>
										)}
									</>
								)}
							/>
						</span>
						<span className="col-1 text-white text-center">
							<Button color="warning" size="sm" className="btn-icon btn-link edit text-danger" onClick={() => remove(jindex)}>
								<FiX />
							</Button>
						</span>
					</div>
				))
			) : (
				<div className="row text-white pt-2">
					<div className="col-12 text-muted">No Learning Objectives Yet</div>
				</div>
			)}
		</div>
	);
};

export const HorizontalLine = () => (
	<div
		className="row"
		style={{
			borderBottom: "2px solid #ffffff25",
			backgroundColor: "#1D253B",
		}}
	></div>
);

export const Accordion = ({ header, children }) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<div className="mt-3 mb-2">
			<a
				aria-expanded={isOpen}
				href="#pablo"
				data-parent="#accordion"
				data-toggle="collapse"
				onClick={(e) => {
					e.preventDefault();
					setIsOpen((prev) => !prev);
				}}
				className="d-flex align-items-center justify-content-between text-white mb-2"
			>
				{header}{" "}
				<i
					className="tim-icons icon-minimal-down ml-5"
					style={{
						transform: isOpen ? "rotate(180deg)" : "",
						transition: "transform 300ms ease",
					}}
				/>
			</a>
			<Collapse role="tabpanel" isOpen={isOpen}>
				{children}
			</Collapse>
		</div>
	);
};
